<template>
  <div class="shopping-mall">
    <shop-header :headerTalg="false"></shop-header>
    <slot></slot>
    <shop-footer></shop-footer>
    <!--右侧固定快捷菜单组件-->
    <fixedRightNav source="shoppingMallStore"></fixedRightNav>
  </div>
</template>

<script>
import shopHeader from './header';
import shopFooter from './footer';
import fixedRightNav from "@/components/common/fixedRightNav.vue";
import {bindAppScrollClosePoppers, unbindAppScrollClosePoppers} from "@/utils/bindAppScrollClosePoppers";

export default {
  name: 'shopmain',
  mounted() {
    this.$nextTick(() => {
      bindAppScrollClosePoppers({
        selector: '#app',
        useRaf: true
      });
    });
  },
  beforeDestroy() {
    unbindAppScrollClosePoppers();
  },
  async created() {
    if (this.$loadProjectTheme) {
      await this.$loadProjectTheme();
    }
    this.$webSocket.initWebSocket();
  },
  components: {
    fixedRightNav,
    shopHeader,
    shopFooter
  }
};
</script>

<style scoped>

</style>
